module.exports = __webpack_public_path__ + "img/upload.d5650cfd.gif";